import EditSquare from "@mui/icons-material/EditSquare";
import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, Stack, Tooltip, useTheme } from "@mui/material";
import ScoutIcon from "components/ScoutIcon";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { SearchThreadsDialog } from "./Search";

export function ScoutToolbar() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { tenantId, conversationId } = useParams();
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Stack
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 1,
      }}
    >
      <Box sx={{ padding: 1 }}>
        <ScoutIcon sx={{ color: theme.palette.encampBlue.main }} />
      </Box>

      <Stack direction="row" alignItems="center">
        {conversationId && (
          <Tooltip title="New conversation">
            <IconButton onClick={() => navigate(`/o/${tenantId}/scout`)}>
              <EditSquare />
            </IconButton>
          </Tooltip>
        )}

        <Tooltip title="Search threads">
          <IconButton onClick={() => setSearchOpen(true)}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      <SearchThreadsDialog
        key={String(searchOpen)}
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </Stack>
  );
}
